import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { RelatedPartySearchResult } from "../../../../Component/Model/Dto/VerificationAgency/Client/Application/RiskAssessment/RelatedParty";
import { DataTableHtmlFormatter } from "../../../../Component/Model/helpers";

interface RelatedPartyRow {
    RelatedUser: string;
    Relationship: string;
    Risk: string;
    RiskMitigated: string;
    Actions: ActionType[];
}

export interface RelatedPartyTable {
    columns: Array<TableColumn>;
    rows: Array<RelatedPartyRow>;
}

export function RelatedPartyTableMapper(dataObject: RelatedPartySearchResult[], deleteRelatedParty: (id: number) => void, edit: (id: number) => void): RelatedPartyTable {
    const columns = [
        { Header: 'Related User', accessor: 'RelatedUser', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Relationship', accessor: 'Relationship', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="300px"/> },
        { Header: 'Risk', accessor: 'Risk', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Risk Mitigated', accessor: 'RiskMitigated', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="300px"/> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (dataObject && dataObject.length > 0) {
        const rows = dataObject.map((item: RelatedPartySearchResult, index: number) => ({
            RelatedUser: item.relatedUser,
            Relationship: DataTableHtmlFormatter(item.relationship, ' '),
            Risk: item.risk,
            RiskMitigated: DataTableHtmlFormatter(item.riskMitigated, ' '),
            Actions: [
                {
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        edit(item.id);
                    },
                    icon: {
                        color: 'grey',
                        name: 'edit'
                    }
                }, {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteRelatedParty(item.id)
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                },
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

